<template>
  <div>
    <v-tooltip bottom>
      <v-btn icon slot="activator" @click.stop="onOpen">
        <v-icon>filter_list</v-icon>
      </v-btn>
      <span>{{ $t('common.search_operations') }}</span>
    </v-tooltip>
    <v-dialog v-model="dialog" persistent max-width="650">
      <v-card>
        <v-card-title>
          <v-icon color="secondary">search</v-icon>
          <span>&ensp;</span>
          <h4>{{ $t('common.search_operations') }}</h4>
        </v-card-title>
        <v-card-text>
          <v-layout row v-if="user.role === 'Administrator'">
            <v-flex xs3 class="text-xs-right grey--text pt-2 pr-3">
              <strong>{{ $t('items.owner') }}</strong>
            </v-flex>
            <v-flex xs5>
              <v-autocomplete
                :items="owners"
                item-text="name"
                item-value="id"
                v-model="search.owner_id"
                class="pt-0"
              ></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs3 class="text-xs-right grey--text pt-2 pr-3">
              <strong>{{ $t('items.name') }}</strong>
            </v-flex>
            <v-flex xs9>
              <v-text-field
                v-model="search.name"
                class="pt-0"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs3 class="text-xs-right grey--text pt-2 pr-3">
              <strong>{{ $t('items.is_mounted') }}</strong>
            </v-flex>
            <v-flex xs9>
              <v-radio-group row v-model="search.mounted">
                <v-radio :label="$t('items.mounted')" :value="true"></v-radio>
                <v-radio :label="$t('items.movable')" :value="false"></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs3 class="text-xs-right grey--text pt-2 pr-3">
              <strong>MANUFACTURER</strong>
            </v-flex>
            <v-flex xs9>
              <v-btn-toggle v-model="search.manufacturer">
                <v-btn
                  v-for="(item, i) in manufacturer"
                  :key="i"
                  :value="item.value"
                  color="primary"
                  class="white--text"
                >
                  <span>{{ item.text }}</span>
                </v-btn>
              </v-btn-toggle>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs3 class="text-xs-right grey--text pt-2 pr-3">
              <strong>{{ $t('items.manufacturer_id') }}</strong>
            </v-flex>
            <v-flex xs9>
              <v-text-field
                v-model="search.manufacturer_id"
                class="pt-0"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs3 class="text-xs-right grey--text pt-2 pr-3">
              <strong>{{ $t('items.status') }}</strong>
            </v-flex>
            <v-flex xs9>
              <v-btn-toggle v-model="search.enabled">
                <v-btn
                  v-for="(item, i) in enabled"
                  :key="i"
                  :value="item.value"
                  :color="item.value ? 'success' : 'error'"
                  class="white--text"
                >
                  <span>{{ $t(`shared.status.${item.text}`) }}</span>
                </v-btn>
              </v-btn-toggle>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn flat color="secondary" @click.stop="onClear">{{ $t('common.clear') }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn flat color="primary" @click.stop="onSearch">{{ $t('common.search') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: ["owners"],
  data() {
    return {
      dialog: false,
      manufacturer: [
        { value: "OBNIZ", text: "obniz" },
        { value: "IOS", text: "ios" },
        { value: "ANDROID", text: "android" }
      ],
      enabled: [
        { value: true, text: "enabled" },
        { value: false, text: "disabled" }
      ],
      search: {}
    };
  },
  computed: {
    ...mapState(["user"])
  },
  methods: {
    onOpen() {
      this.dialog = true;
      this.search = this.$store.getters.search;
    },
    onSearch() {
      this.$store.dispatch("setSearch", this.search);
      this.onFetch();
    },
    onClear() {
      this.$store.dispatch("setSearch", {
        owner_id: "",
        name: "",
        manufacturer_id: ""
      });
      this.onFetch();
    },
    onFetch() {
      this.dialog = false;
      this.$emit("onFetch", this.search);
    }
  }
};
</script>

<style>
</style>
